'use client'

import { AppBar, Box, Container } from '@mui/material'
import { useLoginInfo } from 'app/_hooks'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { useAddLocaleParams } from '~/features/i18n/hooks/useAddLocaleParams'
import { useAxios } from '~/libs/axios'
import { Profile } from '~/types/api/users'
import { MobileHeaderContent } from './HeaderContent/MobileHeaderContent'
import { PcHeaderContent } from './HeaderContent/PcHeaderContent'

export type TitleI18nKey =
  | 'terms'
  | 'search'
  | 'my_page'
  | 'app_settings'
  | 'language_setting'
  | 'to_all_creators'
  | 'home'
  | 'library'
  | 'playlist'
  | 'Account Settings'
  | 'create_profile'
  | 'account_recovery'
  | 'change_payment_method'
  | 'payment_information'
  | 'payment_method'
  | 'register_credit_card'
  | 'register_payment_method'
  | 'change_coupon'
  | 'coupon_list'
  | 'contact'
  | 'privacy_policy'
  | 'withdrawal'
  | 'edit_profile'
  | 'auto_play_setting'
  | 'Sensitive content settings'
  | 'Connect LINE'
  | 'notification'
  | 'Invitations'

export type AppHeaderProps = {
  titleI18nKey?: TitleI18nKey
  title?: string
  /** モバイル時にヘッダーの左側に表示するコンテンツ */
  mobileLeftContent?: ReactNode
  /** モバイル時にヘッダーの右側に表示するコンテンツ */
  mobileRightContent?: ReactNode
}

export const AppHeader = ({
  titleI18nKey,
  title,
  mobileLeftContent,
  mobileRightContent,
}: AppHeaderProps) => {
  const axios = useAxios()
  const localeParams = useAddLocaleParams()
  const loginInfo = useLoginInfo()

  const { t } = useTranslation()
  const titleText = titleI18nKey ? t(titleI18nKey) : title

  const { data: profile, error: profileError } = useSWR<Profile>(
    loginInfo.status !== 'notSignedIn' ? `/v2/user/edit?${localeParams}` : null,
    (args: string) => axios.get(args).then((res) => res.data),
  )

  return (
    <AppBar sx={{ backgroundColor: 'black' }}>
      {titleText && <title>{`${titleText} - SAMANSA`}</title>}
      {titleText && <meta property='og:title' content={`${titleText} - SAMANSA`} />}
      {titleText && <meta property='og:site_name' content={`${titleText} - SAMANSA`} />}
      <Container maxWidth='xl' sx={{ position: 'relative' }}>
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          <PcHeaderContent loginState={loginInfo.status} avatarUrl={profile?.avatar_url || ''} />
        </Box>
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <MobileHeaderContent
            title={titleText ?? ''}
            rightContent={mobileRightContent}
            leftContent={mobileLeftContent}
          />
        </Box>
      </Container>
    </AppBar>
  )
}
